import { useCallback, useEffect, useState } from 'react'
import { collection, deleteDoc, doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore'
import { useAuth } from '../../contexts/AuthContext'
import { db } from '../../lib/firebase'
import { requestGenerationSignIn } from '../../lib/authRequired'

export function useStyleFavorites() {
  const { user } = useAuth()
  const [favoriteIds, setFavoriteIds] = useState<string[]>([])

  useEffect(() => {
    if (!user?.uid || !db) {
      setFavoriteIds([])
      return
    }
    setFavoriteIds([])
    return onSnapshot(collection(db, 'users', user.uid, 'styleFavorites'), (snapshot) => {
      setFavoriteIds(snapshot.docs.map((item) => item.id))
    }, (error) => {
      console.warn('[Voxnela] Favoriler yüklenemedi.', error)
    })
  }, [user?.uid])

  const toggleFavorite = useCallback(async (styleId: string) => {
    if (!user?.uid || !db) {
      requestGenerationSignIn()
      return
    }
    const favoriteRef = doc(db, 'users', user.uid, 'styleFavorites', styleId)
    if (favoriteIds.includes(styleId)) {
      await deleteDoc(favoriteRef)
    } else {
      await setDoc(favoriteRef, { styleId, createdAt: serverTimestamp() })
    }
  }, [favoriteIds, user])

  return { favoriteIds, toggleFavorite }
}
